import AppCatalog from "../../../services/App/AppCatalog.js";
import AppModule from "../../../services/App/AppModule.js";
import Catalog from "../UserCatalog.js";

export default {
  Search: {
    Label: AppCatalog.Field.Search.Label + " " +
      Catalog.Name.Label,
    Type: AppCatalog.Field.Search.Type,
    MaxLength: AppCatalog.Field.Search.MaxLength,
    Param: AppCatalog.Field.Search.Param 
  },
  AccessID: {
    Label: Catalog.AccessID.Label,
    Type: AppCatalog.Field.ID.Type,
    Input: AppCatalog.Field.ID.Input,
    Param: AppModule.Access.Param + AppCatalog.Field.ID.Param
  },
  IsActive: {
    Label: Catalog.IsActive.Label,
    Type: AppCatalog.Field.IsActive.SearchType,
    Input: AppCatalog.Field.IsActive.SearchInput,
    Param: AppCatalog.Field.IsActive.Param
  }
}